import Section from "../../layout/Section/Section";
import styles from "./HowItWorks.module.css";

const steps = [
  {
    title: "First, we listen.",
    text: "A short call about your business, your customers, and what you want people to find when they search.",
    meta: "Day 1 · Discover",
  },
  {
    title: "Then, we build.",
    text: "We set up your Google profile, fine-tune your Maps presence, and build a website if you need one.",
    meta: "Days 2–7 · Create",
  },
  {
    title: "You're ready to be found.",
    text: "We launch, check everything on mobile, and walk you through keeping your new online presence fresh.",
    meta: "Days 7–10 · Launch",
  },
];

export default function HowItWorks() {
  return (
    <Section id="how-it-works" className={styles.section} bg="transparent">
      <header className={styles.head}>
        <div>
          <span className={styles.eyebrow}>Simple from the start</span>
          <h2 className={styles.heading}>Your next chapter.<br /><span>Three simple steps.</span></h2>
        </div>
        <p className={styles.intro}>You focus on your business.<br />We take care of bringing it online.</p>
      </header>
      <ol className={styles.steps}>
        {steps.map((step, index) => (
          <li key={step.title} className={styles.step}>
            <div className={styles.stepTop}>
              <span className={styles.number}>0{index + 1}</span>
              <span className={styles.line} aria-hidden="true" />
              <span className={styles.dot} aria-hidden="true" />
            </div>
            <span className={styles.meta}>{step.meta}</span>
            <h3 className={styles.title}>{step.title}</h3>
            <p className={styles.text}>{step.text}</p>
          </li>
        ))}
      </ol>
      <div className={styles.foot}>
        <span><span className={styles.statusDot} aria-hidden="true" />No jargon. No long contracts. Just a clear way forward.</span>
        <a href="/contact">Let's get started <span aria-hidden="true">↗</span></a>
      </div>
    </Section>
  );
}
